export const updateMinutes = (
  setMinutes: (minutes: number) => any,
  setHours: (hours: number) => any,
  change: string,
  amount: number | string,
  previousHours: any,
  previousMinutes: any
) => {
  const newAmount = Number(amount);

  const currentMinutes = parseInt(previousMinutes, 10);
  const currentHours = parseInt(previousHours, 10);

  // Round up any minute value to the next multiple of 5
  const roundUpToNext5 = (m: number) => Math.ceil(m / 5) * 5;

  if (change === "initial") {
    const totalMinutes = currentMinutes + newAmount;
    // Calculate how many full hours are added
    const additionalHours = Math.floor(totalMinutes / 60);

    // Round remaining minutes up to the next 5-minute mark
    const rounded = roundUpToNext5(totalMinutes % 60);

    // Calculate final hours (accounting for hour overflow if minutes reach 60)
    const finalHours = (currentHours + additionalHours + (rounded === 60 ? 1 : 0)) % 24;
    // If rounded minutes hit 60, reset to 0
    const finalMinutes = rounded === 60 ? 0 : rounded;

    setMinutes(finalMinutes);
    setHours(finalHours);
  } else if (change === "increase") {
    const hours =
      currentMinutes > 54 ? (currentHours > 22 ? 0 : currentHours + 1) : previousHours == "0" ? 0 : currentHours;
    const minutes = currentMinutes > 54 ? 0 : currentMinutes + newAmount - (currentMinutes % 5);

    setMinutes(minutes);
    setHours(hours);
  } else if (change === "decrease") {
    const hours =
      currentMinutes < 5
        ? currentHours < 2
          ? currentHours < 1
            ? 23
            : 0
          : currentHours - 1
        : previousHours == "0"
        ? 0
        : currentHours;
    const minutes =
      currentMinutes < 6 ? (currentMinutes == 5 ? 0 : 55) : currentMinutes - newAmount - (currentMinutes % 5);

    setMinutes(minutes);
    setHours(hours);
  } else {
    setMinutes(newAmount > 59 ? 59 : newAmount);
  }
};
